import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';

export function requireRole(roles=[], Component) {
  return (props) => {
    const user = useSelector((store) => store.user);

    if (!_.includes(_.flatten([roles]), user.role)) return <Redirect to="/"/>;

    return <Component currentUser={user} {...props}/>;
  }
}
